module.exports = __webpack_public_path__ + "static/product_hire-23092988feb748030721b9a50b986a93.png";